import { Route, Routes } from 'react-router-dom';
import Influencers from '../components/influencers';
import { MainSection } from '../components/MainSection';
import PostSchedule from '../components/post-schedule';
import { DocumentsProvider } from '../context/DocumentsContext';
import { DocumentsProviderV2 } from '../context/DocumentsContextV2';
import PBNewsGrid from '../pages/PBNewsGrid';
import PBNewsArticle from '../pages/PBNewsArticle';

import AboutUs from '../pages/AboutUs';
import ActorsCasting from '../pages/actorsCasting';
import AdvertisingPromotions from '../pages/advertisement-promotions';
import AiEditPage from '../pages/AiEditPage';
import ApplyProjects from '../pages/applyprojects';
import Blog from '../pages/Blog';
import Lodings from '../components/lodingpages';
import Budget from '../pages/Budget';
import BudgetHowTo from '../pages/budgetHowTo';
import Payment from '../pages/Payment';
import Calender from '../pages/calender';
import { AllAvailCareers, Apply, Career } from '../pages/careers';
import Castmanagement from '../pages/cast-management';
import ProjectStarter from '../pages/ProjectStarter';
import CastingHowTo from '../pages/castingHowTo';
import ChatBot from '../pages/chatbot';
import Cookies from '../pages/cookies';
import Clients from '../pages/clients';
import Company from '../pages/company';
import Connect from '../pages/connect';
import ContactUs from '../pages/Contactus';
import Cllaborativeecosystem from '../pages/collaborative-ecosystem';
import Feedback from '../pages/feedback';
import CreateNewPassword from '../pages/CreateNewPassword';
import DigitalMarketing from '../pages/digital-marketing';
import Distributions from '../pages/distributions';
import DocumentsPage from '../pages/DocumentsPage';
import EditDocumentPage from '../pages/EditDocumentPage';
import EditingPage from '../pages/EditingPage';
import EditOptionsPage from '../pages/EditOptionsPage';
import Error from '../pages/Error';
import Events from '../pages/events';
import Complete from '../pages/CompleSingUp'
import StudentProgramSignup from '../pages/StudentProgramSignup';
import StudentProgram from '../pages/StudentProgram';
import AboutAiwork from '../pages/AIintregationau';
import FilmEnthusiastDashboard from '../pages/filmenthusiast';
import ForgotPassword from '../pages/forgotpassword';
import HowTo from '../pages/howTo';
import ResetPassword from '../pages/resetPassword';
import Itunes from '../pages/itunes';
import JobPostings from '../pages/jobpostings';
import Loading from '../pages/loading';
import { Location } from '../pages/Location';
import LocationHowTo from '../pages/locationHowTo';
import Login from '../pages/login';
import ManualEditPage from '../pages/ManualEditPage';
import MarketAnalysis from '../pages/marketAnalysis';
import MarketingAgencyDashboard from '../pages/marketingagencies';
import Messenger from '../pages/Messenger';
import MyProjects from '../pages/myprojects';
import ProductionStageAdvertising from '../pages/productionStageAdvertising';
import NetflixDistributors from '../pages/netflixDistributios';
import OurWork from '../pages/our_work'; // Corrected import
import PaidPromotions from '../pages/paid-promotions';
import Portfolio from '../pages/portfolio';
import PostDescription from '../pages/post-description';
import PostProductionAnalysis from '../pages/post-productionAnalysis';
import PostDashboard from '../pages/postDashboard';
import PosterGenerationPage from '../pages/PosterGenerationPage';
import { PostStages } from '../pages/postStages';
import PreProductionDashboard from '../pages/PreProductionDashboard';
import Prime from '../pages/prime';
import { PrivacyPolicy } from '../pages/privacyPolicy';
import ProductionDashboard from '../pages/ProductionDashboard';
import ProductionHouseDashboard from '../pages/productionhouse';
import ProgressTracker from '../pages/progressTracker';
import PromotionsPage from '../pages/promotionsPage';
import ROI from '../pages/ROI';
import Script from '../pages/script';
import ScriptAnalysisHowTo from '../pages/scriptAnalysisHowTo';
import Service from '../pages/Services'
import EarlyAccessPage from '../pages/EarlyAccessPage';
import Signup from '../pages/signup';
import { Stages } from '../pages/Stages';
import Team from '../pages/team';
import TermsAndConditions from '../pages/terms&conditions';
import VideoEditorPage from '../pages/VideoEditorPage';
import { Welcome } from '../pages/Welcome';
import DocumentationTool from '../pages/DocumentationTool';
import Dashboard from './Dashboard';
import StudentDashboard from '../pages/StudentDashboard';
import StudentPortal from '../pages/StudentPortal';
import StudentToolSelector from '../components/studentPortal/StudentToolSelector';
import EditorPage from './EditorPage';
import EventsSection from './eventsection';
import TemplatePage from './TemplatePage';
import ToolSelector from '../pages/ProjectSelector';
import Ebook from '../pages/Ebook';
import SettingPrivicy from '../pages/SettingPrivicy';
// import AboutUs from '../pages/AboutUs';
import AddCompanyHistory from '../pages/addCompanyHistory';
import CollaborationsTable from '../pages/collaborations';
import CompanyDetails from '../pages/companyDetails';
import EnthusiastSchedule from '../pages/enthusiast-schedule';
import JobApplications from '../pages/jobApplications';
import CampaignTracker from '../pages/marketing-tracker';
import ProductionHouseSetup from '../pages/ProductionHouseSetup';
import MarketingTeam from '../pages/marketingTeam';
import MarketingTeamSchedule from '../pages/marketingTeamSchedule';
import ProductionStatus from '../pages/productionStatus';
import Allinone from '../pages/all-in-one-tools';
import ProjectStatus from '../pages/projectCollab';
import TeamSchedule from '../pages/teamSchedule';
import Endtoend from '../pages/end-to-end-solution';
import Trailer from '../pages/trailer';
import { Settings } from '../pages/settings';
import MessagingFeaturePage from '../pages/MessagingFeaturePage';
import Comunity from '../pages/comunity';
import CinematicAILoading from '../components/lodingpages';
import AdBanner from '../components/AdBanner';
import ScriptEditor from '../components/ScriptEditor';
import ScriptBreakdown from '../components/ScriptBreakdown';
import CastingGuide from '../pages/CastingGuide';
import PostProductionGuide from '../pages/PostProductionGuides';
import DistributionGuide from '../pages/DistributionGuide'
import FilmProductionGuide from '../pages/FilmProductionGuides';
import DisplayProject from '../pages/DisplayProject';
//books
import Scriptwritter from '../components/books/Scriptwritter';
import ResetPw from '../pages/resetPwPage';

import VintageParchment from '../pages/test';
import ToolManager from '../pages/ToolManager';
import PaymentPage from '../pages/Paymentpage';
/* To-do set up specific pages with page loader
const PageLoader = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 7300); // Adjust timing as needed

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isLoading) {
    return <CinematicAILoading />;
  }

  return children;
}
*/

function Routing() {
  return (
    <DocumentsProvider>
      <DocumentsProviderV2>
        {/*
        <LoadingProvider>
          <PageLoader>
          */}
        <Routes>
          <Route path='/test' element={<VintageParchment />} />
          <Route path='/toolmanager' element={<ToolManager />} />
          <Route path='/' element={<MainSection />} />
          <Route path='/welcome' element={<Welcome />} />
          <Route path='/feedback' element={<Feedback />} />
          <Route path='/budget/:projectId' element={<Budget />} />
          <Route path='/location/:projectId' element={<Location />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/resetPassword' element={<ResetPassword />} />
          <Route path='/input/:projectId' element={<Script />} />
          <Route path='/end-to-end-solution' element={<Endtoend />} />
          <Route path='/payment/:cartId' element={<PaymentPage />} />
          <Route path="/production-house-setup" element={<ProductionHouseSetup />} />
          <Route path='/lodingpages' element={<Lodings />} />
          <Route path='/stages' element={<Stages />} />
          <Route path='/loading' element={<Loading />} />
          <Route path='/collaborative-ecosystem' element={<Cllaborativeecosystem />} />
          <Route path='*' element={<Error />} />
          <Route path='/complete-profile' element={<Complete />} />
          <Route path='/student-program/signup' element={<StudentProgramSignup />} />
          <Route path='/student-program/continue' element={<StudentProgramSignup />} />
          <Route path='/student-program' element={<StudentProgram />} />
          <Route path='/Comunity' element={<Comunity />} />
          <Route path='/all-in-one-tools' element={<Allinone />} />
          <Route path="/film-production-guide" element={<FilmProductionGuide />} />
          <Route path='/services' element={<Service />} />
          <Route path="/earlyacess" element={<EarlyAccessPage />} />
          <Route path='/news' element={<PBNewsGrid />} />
          <Route path='/news/:slug' element={<PBNewsArticle />} />          


          <Route path='/AIintregationau' element={<AboutAiwork />} />
          <Route path='/cast-management/:projectId' element={<Castmanagement />} />
          <Route path='/howTo' element={<HowTo />} />
          <Route path='/messenger' element={<Messenger />} />
          <Route path='/messenger/:userId' element={<Messenger />} />
          <Route path="/tracker/:projectId" element={<ProgressTracker />} />
          <Route path="/post-production" element={<PostDashboard />} />
          <Route path="/calender" element={<Calender />} />
          <Route path="/cast/:projectId" element={<ActorsCasting />} />
          <Route path="/Our_Work" element={<OurWork />} /> {/* Corrected usage */}
          <Route path="/SettingPrivicy" element={<SettingPrivicy />} />
          <Route path="/changepass/:user_id" element={<ResetPw />} />
          <Route path="/Ebook" element={<Ebook />} />
          <Route path="/casting-guide" element={<CastingGuide />} />
          <Route path="/display-project/:ad_id" element={<DisplayProject />} />
          <Route path="/distributions/:projectId" element={<Distributions />} />
          <Route path="/post-production-guide" element={<PostProductionGuide />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route
            path="/understandpilo-messenger"
            element={<MessagingFeaturePage />}  // ← correct spelling
          />
          <Route path='/loadingTest' element={<CinematicAILoading />} />
          <Route path="/distribution-guide" element={<DistributionGuide />} />

          <Route path="/post-stage" element={<PostStages />} />
          <Route path="/production-advertising" element={<ProductionStageAdvertising />} />
          <Route path='/pre-production' element={<PreProductionDashboard />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/promotion/:projectId" element={<PromotionsPage />} />
          <Route path="/netflix" element={<NetflixDistributors />} />
          <Route path="/prime" element={<Prime />} />
          <Route path="/itunes" element={<Itunes />} />
          <Route path="/post-schedule/:projectId" element={<PostSchedule />} />
          <Route path="/advertisement-promotions/:projectId" element={<AdvertisingPromotions />} />
          <Route path="/influencers" element={<Influencers />} />
          <Route path="/digital" element={<DigitalMarketing />} />
          <Route path="/paid" element={<PaidPromotions />} />
          <Route path="/description" element={<PostDescription />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/roi" element={<ROI />} />
          <Route path="/company" element={<Company />} />
          <Route path="/events" element={<Events />} />
          <Route path='/careers/apply/:id' element={<Apply />} />
          <Route path='/starter' element={<ProjectStarter />} />
          <Route path='/chatbot' element={<ChatBot />} />
          <Route path='/careers' element={<AllAvailCareers />} />
          <Route path='/careers/:id' element={<Career />} />
          <Route path='/AboutUS' element={<AboutUs />} />
          <Route path='/contactus' element={<ContactUs />} />
          <Route path='/create-newpassword' element={<CreateNewPassword />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/toolselector' element={<ToolSelector />} />
          <Route path='/toolselector/:projectId' element={<ToolSelector />} />
          <Route path="/schedule/:projectId" element={<EventsSection />} />
          <Route path="/script-editor" element={<ScriptEditor />} />
          <Route path="/script-breakdown" element={<ScriptBreakdown />} />
          <Route path="/documents/:projectId" element={<DocumentsPage />} />
          <Route path="/editing/:projectId" element={<EditingPage />} />
          <Route path="/template" element={<TemplatePage />} />
          <Route path="/edit/:id" element={<EditDocumentPage />} />
          <Route path="/editor" element={<EditorPage />} />
          <Route path="/dashboard" element={<Dashboard />} /> {/* Add route for Dashboard */}
          <Route path="/student-dashboard" element={<StudentDashboard />} /> {/* PLAN S11a - superseded by StudentPortal below, left in place, not wired to anything now */}
          <Route path="/my-producer-buddy-studentportal" element={<StudentPortal />} /> {/* Redesigned student portal - Dashboard.jsx redirects verified students here */}
          <Route path="/my-producer-buddy-studentportal/project/:projectId" element={<StudentToolSelector />} /> {/* Free-tier tool launcher - navigates to the existing /input, /budget, /cast, /location pages, bypassing ProjectSelector.jsx's subscription-only flow for verified students */}
          <Route path="/edit-options" element={<EditOptionsPage />} />
          <Route path="/ai-edit" element={<AiEditPage />} />
          <Route path="/manualedit" element={<ManualEditPage />} />
          <Route path="/vfx/:projectId" element={<VideoEditorPage />} />
          <Route path="/progesstracker/:projectId" element={<ProgressTracker />} />
          <Route path="/calender" element={<Calender />} />
          <Route path="/AdBanner" element={<AdBanner />} />
          <Route path="/production" element={<ProductionDashboard />} />
          <Route path="/postergenerationpage/:projectId" element={<PosterGenerationPage />} />
          <Route path='/SAHowTo' element={<ScriptAnalysisHowTo />} />
          <Route path='/budgetHowTo' element={<BudgetHowTo />} />
          <Route path='/locationHowTo' element={<LocationHowTo />} />
          <Route path='/castHowTo' element={<CastingHowTo />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/DocumentationTool" element={<DocumentationTool />} />
          <Route path="/market-analysis" element={<MarketAnalysis />} />
          <Route path="/film-enthusiast" element={<FilmEnthusiastDashboard />} />
          <Route path="/production-house" element={<ProductionHouseDashboard />} />
          <Route path="/marketing-agencies" element={<MarketingAgencyDashboard />} />
          <Route path="/applyprojects" element={<ApplyProjects />} />
          <Route path="/myprojects" element={<MyProjects />} />
          <Route path="/jobpostings" element={<JobPostings />} />
          <Route path="/team" element={<Team />} />
          <Route path="/marketing-team" element={<MarketingTeam />} />
          <Route path="/trailer/:projectId" element={<Trailer />} />
          <Route path="/post-analysis/:projectId" element={<PostProductionAnalysis />} />
          <Route path="/collaborations" element={<CollaborationsTable />} />
          <Route path="/team-schedule/:id" element={<TeamSchedule />} />
          <Route path="/marketing-schedule/:id" element={<MarketingTeamSchedule />} />
          <Route path="/enthusiast-schedule" element={<EnthusiastSchedule />} />
          <Route path='/policy' element={<PrivacyPolicy />} />
          <Route path='/marketing-tracker' element={<CampaignTracker />} />
          <Route path='/add-company' element={<AddCompanyHistory />} />
          <Route path='/company-details' element={<CompanyDetails />} />
          <Route path='/marketing-collaborations' element={<ProjectStatus />} />
          <Route path='/clients' element={<Clients />} />
          <Route path="/job-applications/:id" element={<JobApplications />} />
          <Route path="/production-status" element={<ProductionStatus />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/Scriptwritter' element={<Scriptwritter />} />
        </Routes>
        {/*
          </PageLoader>
        </LoadingProvider>
        */}
      </DocumentsProviderV2>
    </DocumentsProvider>
  );
}

export default Routing;
